import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { Root } from './Root';

const sidebarContent = NavContentBlueprint.make({
  name: 'sidebar-content',
  params: {
    component: Root,
  },
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [sidebarContent],
});
